import { useToastListener } from '../../hooks/useToast'

export default function ToastStack() {
  const toasts = useToastListener()

  if (toasts.length === 0) return null

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`rounded-lg border shadow-lg px-4 py-3 text-sm animate-in slide-in-from-bottom-2
            ${toast.variant === 'destructive'
              ? 'border-destructive bg-destructive text-destructive-foreground'
              : 'border-border bg-popover text-popover-foreground'
            }`}
        >
          <div className="font-medium">{toast.title}</div>
          {toast.description && (
            <div className="text-xs opacity-80 mt-0.5 font-mono truncate">{toast.description}</div>
          )}
        </div>
      ))}
    </div>
  )
}
